<template>
  <div>
    <div class="download-tab">
      <ul class="nav nav-tabs" id="myTab">
        <li>
          <router-link :to="{ name: 'download' }">
            <i class="iconfont icon-windows"></i>
            <span class="client-name">Windows</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'downloadAndroid' }">
            <i class="iconfont icon-android"></i>
            <span class="client-name">Android</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'downloadIphone' }">
            <i class="iconfont icon-ios1"></i>
            <span class="client-name">iPhone/iPad</span>
          </router-link>
        </li>
        <li class="active">
          <a>
            <i class="iconfont icon-windows-tb"></i>
            <span class="client-name">Windows同步端(测试版)</span>
          </a>
        </li>
        <!-- <li>
          <router-link :to="{ name: 'downloadIphoneSync' }">
            <i class="iconfont icon-ios-tb"></i>
            <span class="client-name">Mac同步端</span>
          </router-link>
        </li> -->
      </ul>
    </div>
    <div class="download clearfix">
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade in active" id="pc">
          <div class="pic">
            <img src="@/assets/images/dbg-sync.png" />
          </div>
          <div class="detail">
            <h1>Windows同步端(测试版)</h1>
            <h2>本地与云端文件(夹)实时同步</h2>
            <h3 data-toggle="modal" data-target="#tips">
              阅读睿客云盘Windows同步端(测试版)体验须知
            </h3>
            <div class="btnbox">
              <button
                class="btn btn-primary"
                type="button"
                data-toggle="modal"
                data-target="#tips"
              >
                下载安装包
              </button>
            </div>
            <div class="info">
              <ul>
                <li>适应系统：win7 / win8 / win10</li>
                <li>更新时间：{{ this.releases.released_at }}</li>
                <li>
                  版本：{{ this.releases.version_no }}
                  <router-link :to="{ name: 'updatelogWindowsSync' }"
                    >查看详细</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-labelledby="myModalLabel"
      class="modal fade"
      id="tips"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title" id="myModalLabel">
              睿客云盘Windows同步端（测试版）体验须知
            </h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <span style="font-weight: 700"
                >1.如何参与体验睿客云盘Windows同步端（测试版）？</span
              ><br />
             睿客网用户均可参与测试。测试版本，可通过睿客网客户端下载界面（https://rec.ustc.edu.cn/download）,选择“Windows同步端（测试版）”下载。<br /><br />
              <span style="font-weight: 700"
                >2.安装使用Windows同步端（测试版）前须知</span
              ><br />
              1）您的操作系统需要是Windows7及以上的版本；<br />
              2）由于客户端仍是测试版，可能会包含错误或不准确信息，使用期间请不要通过测试版同步重要文件和数据；<br />
              3）同步客户端会将：<br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a.本地与云端发生冲突的文件，放置在与同步文件夹同级目录的“&lt;XXX&gt;的睿客云盘_冲突”文件夹中；<br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;b.客户端同步时删除的文件/文件夹，放置在与同步文件夹同级目录的“&lt;XXX&gt;的睿客云盘_回收站”文件夹中；
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;上述两个文件夹中内容，在您确认不需要时，可随时删除它来释放磁盘空间。<br />
              4）在使用过程中，欢迎通过邮件rec@ustc.edu.cn，反馈您的问题和建议。<br /><br /><br />
              <button
                :class="['btn btn-lg', accept ? 'btn-primary' : 'btn-default']"
                type="button"
                @click="downloadInstall"
              >
                <input type="checkbox" v-model="accept" @click.stop="false" />
                同意并下载
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { clientReleases } from "@/api/common/index";
export default {
  name: "DownloadWindowsSync",
  data() {
    return {
      accept: false,
      releases: {
        terminal_name: "",
        download_install: "",
        download_unzip: "",
        created_at: "",
        version_no: "",
      },
    };
  },
  created() {
    this.$store.commit("SET_THEME", "客户端下载");
    this.clientReleases();
  },
  methods: {
    // 获取PC版本等信息
    clientReleases() {
      clientReleases({
        offset: 0,
        limit: 1,
        terminal_type: "6",
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.releases = res.entity[0];
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 下载安装包
    downloadInstall() {
      if (this.accept) {
        window.location.href = this.releases.download_install;
      } else {
        this.$message({
          type: "warning",
          message: "请先勾选同意",
        });
      }
    },
  },
};
</script>

<style scoped>
@media (max-width: 768px) {
  .modal-dialog {
    width: 90%;
  }
  .download h3 {
    text-align: center;
  }
}
.download h3 {
  color: red;
  font-size: 18px;
  margin-top: 20px;
  cursor: pointer;
}
</style>